export enum fetchStatuses {
  idle = 'idle',
  pending = 'pending',
  success = 'success',
  rejected = 'rejected',
}
